import produce from 'immer';

export default {
  saveSimplified: produce((state, entities) => {
    (entities || []).forEach((entity: any) => {
      const target = state.codes[entity.code] || {};
      state.codes[entity.code] = {
        ...target,
        ...entity,
        isSimplified: target?.isSimplified ?? true,
      };
    });
  }),
  saves: produce((state, entities) => {
    (entities || []).forEach((entity: any) => {
      state.codes[entity.code] = entity;
    });
  }),
  update: produce((state, entity) => {
    state.codes[entity.code] = {
      ...state[entity.code],
      ...entity,
    };
  }),
  delete: produce((state, entity) => {
    delete state.codes[entity.code];
  }),
};
